/**
 * Created by mukund on 6/10/15.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('upload', {
                parent: 'site',
                url: '/upload',
                data: {
                    roles: [],
                    pageTitle: 'upload.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/upload/templates/upload.html',
                        controller: 'UploadController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('upload');
                        return $translate.refresh();
                    }]
                }
            });
    });
